import script from "./profileMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./profileMenu.vue?vue&type=script&setup=true&lang=js"

import "./profileMenu.vue?vue&type=style&index=0&id=d99c53a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d99c53a4"]])

export default __exports__